import React from 'react';

const results = () => (
  <div>Vote list</div>
);

export default results;



// WEBPACK FOOTER //
// ./focus_groups/containers/vote_list.js